<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')" class="video">
		<VideoDescTop></VideoDescTop>
		<el-form label-position="left">
			<el-form-item label="故事影片連結" class="form-item" :class="{'color-danger':!video.src}">{{video.src || '尚未上傳'}}</el-form-item>
		</el-form>
		<VideoDescBottom></VideoDescBottom>
	</brows-layout>
</template>

<script>
import BrowsLayout from "./BrowsLayout.vue";
import VideoDescTop from "./VideoDescTop.vue";
import VideoDescBottom from "./VideoDescBottom.vue";
import { mapState } from "vuex";

export default {
	data() {
		return {};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		video() {
			return {
				...this.editStoryData.video
			};
		}
	},
	methods: {},
	created() { },
	mounted() { },
	components: {
		BrowsLayout,
		VideoDescTop,
		VideoDescBottom
	}
};
</script>

<style lang="scss" scoped>
.video {
	font-size: 14px;

	.story-video {
		margin-top: 26px;
	}

	.ori-video {
		margin-top: 22px;
	}

	.viedo-description {
		padding-left: 100px;
		font-size: 12px;
		margin-top: 17px;

		.link-tips {
			margin-bottom: 35px;
		}

		.names-description {
			margin-bottom: 25px;
		}

		.names-rules {
			margin-bottom: 25px;
		}
	}
}
</style>